<template>
  <div class="part-item projectBuilding">
    <p class="part-title">附件材料清单
    </p>
    <div class="part-content">
      <span class="content-title">1. 课程团队成员和课程内容政治审查意见（必须提供）：</span>
      <div class="content-text">
        <p class="fangsong">（申报课程高校党委负责对本校课程团队成员以及申报课程的内容进行政审，出具政审意见并加盖党委印章；团队成员涉及多校时，各校党委分别对本校人员出具意见；非高校成员由其所在单位党组织出具意见。团队成员政审意见内容包括政治表现、是否存在违法违纪记录、师德师风、学术不端、五年内是否出现过重大教学事故等问题；课程内容审查包括价值取向是否正确，对于我国政治制度以及党的理论、路线、方针、政策等理解和表述是否准确无误，对于国家主权、领土表述及标注是否准确，等等。）</p>
        <template v-if="formInfo.materials_file && formInfo.materials_file.politicalArry">
          <p
            v-for="(file,key) in formInfo.materials_file.politicalArry"
            :key="key"
          >
            <a
              target="_blank"
              :href="file?file.path:'javascript:;'"
              :download="file?file.name:''"
            >{{file.name}}</a>
          </p>
        </template>
        <span
          v-else
          class="content-title"
        >暂无内容</span>
      </div>
      <div class="clearfix"></div>
      <span class="content-title">2. 课程内容学术性评价意见（必须提供）：</span>
      <div class="content-text">
        <p class="fangsong">（由学校学术性组织（校教指委或学术委员会等），或相关部门组织的相应学科专业领域专家（不少于3名）组成的学术审查小组，经一定程序评价后出具。须由学术性组织盖章或学术审查小组全部专家签字。无统一格式要求。）</p>
        <template v-if="formInfo.materials_file && formInfo.materials_file.learnArry">
          <p
            v-for="(file,key) in formInfo.materials_file.learnArry"
            :key="key"
          >
            <a
              target="_blank"
              :href="file?file.path:'javascript:;'"
              :download="file?file.name:''"
            >{{file.name}}</a>
          </p>
        </template>
        <span
          v-else
          class="content-title"
        >暂无内容</span>
      </div>
      <div class="clearfix"></div>
      <span class="content-title">3. 校外评价意见（可选提供）：</span>
      <div class="content-text">
        <p class="fangsong">（评价意见作为课程有关学术水平、课程质量、应用效果等某一方面的佐证性材料或补充材料，可由课程应用高校或社会应用机构等出具。评价意见须经相关单位盖章，以1份为宜，不得超过２份。无统一格式要求。）</p>
        <template v-if="formInfo.materials_file && formInfo.materials_file.outsideArry">
          <p
            v-for="(file,key) in formInfo.materials_file.outsideArry"
            :key="key"
          >
            <a
              target="_blank"
              :href="file?file.path:'javascript:;'"
              :download="file?file.name:''"
            >{{file.name}}</a>
          </p>
        </template>
        <span
          v-else
          class="content-title"
        >暂无内容</span>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Material',
  props: ['expId'],
  data() {
    return {
      formInfo: {
        materials_file: {
          politicalArry: [],
          learnArry: [],
          outsideArry: []
        }
      }

    }
  },
  methods: {

    async getInfo() {
      const url = '/allowany/experiment/' + this.expId + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo = data
        this.formInfo.materials_file = data.materials_file ? JSON.parse(data.materials_file) : {
          politicalArry: [],
          learnArry: [],
          outsideArry: []
        }
      }).catch((error) => {
        console.log(error)
      })
    }

  },
  async mounted() {
    await this.getInfo()
  }
}
</script>

<style scoped src="../../assets/css/project-manage.css"></style>

<style lang="less" scoped>
.fangsong {
  margin-bottom: 10px;
  color: rgb(144, 144, 144);
}
</style>
